import React from "react";
import styles from "./Logo.module.css";

const Logo = (props) => {
	const sourceLogo = require(`./${props.source.toLowerCase()}.png`);
	return (
		<div
			className={styles.main}
			onClick={() => {
				window.open("https://www.zameen.com");
			}}
		>
			<img
				src={sourceLogo}
				alt={`${props.source} Logo`}
				className={styles.img}
			/>
		</div>
	);
};

export default Logo;
